import React from 'react';
import {
  link2ShowHotel,
  getHotelDetails
} from '../../../../../../../services/services';
import Loader from '../../../../../../../common/components/loader';
import { T } from '../../../../../../../../../common/locale/translate';

import OfferLocationHeader from '../../../../../../../common/components/offer-location-header';
import Facilities from './facilities';
import Details from './details';
import Price from '../../../../../../../common/components/price';
import Categories from './categories';
import Operator from './operator';
import OfferVariants from '../../../../../../../common/components/offer-variants';

export default class OfferWithHotelElement extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      variantsActive: false,
      variantsActiveText: T('hide_prices'),
      variantsInActiveText: T('show_dates_with_prices'),
      offerLink: 'javascript:void(0)',
      params: props.params,
      pristine: true,
      loaderText: T('prices_and_dates_loading'),
      main_image: props.data.subject.thumbnail_url,
      image_loader: false,
      is_price_estimated: true
    };
  }

  componentDidMount() {
    if (!this.state.main_image) {
      this.setState({ image_loader: true }, this.fetchImage());
    }
  }

  render() {
    const data = this.props.data;
    const params = this.offerLinkParams();
    return (
      <article className={`hotel-offer-wrapper ${this.props.preloadClass}`}>
        <div className="offer">
          <div className="image-section">
            <a
              href={link2ShowHotel(params, data.description_link)}
              rel="nofollow"
              title={this.descriptionLinkTitle(data.subject.name)}
            >
              <Loader
                active={this.state.image_loader}
                className="image-loader"
              />
              {this.state.image_loader || (
                <figure
                  className="hotel-image"
                  style={{
                    backgroundImage: `url(${this.state.main_image ||
                      '/img/placeholder/250x240.png'})`
                  }}
                  alt={data.subject.name}
                >
                  <Categories data={data} />
                </figure>
              )}
            </a>
          </div>
          <div className="offer-description-wrapper">
            <div className="offer-description">
              <div className="headers">
                <OfferLocationHeader
                  region_id={data.subject.region_id}
                  city={data.subject.city}
                  offer_type={data.offer_type}
                  regions={this.props.regions}
                />
                <h2 className="title">
                  {' '}
                  <a
                    href={link2ShowHotel(params, data.description_link)}
                    rel="nofollow"
                    title={this.descriptionLinkTitle(data.subject.name)}
                  >
                    {' '}
                    {data.subject.name}{' '}
                  </a>{' '}
                </h2>
                <span
                  className={`stars stars-${(data.subject.rating + '')
                    .split('.')
                    .join('')}`}
                />
              </div>
              <Facilities facilities={data.subject.facilities} />
              <div className="operator-wrapper">
                <Operator operator={data.operator} />
              </div>
            </div>
            <div className="prices-and-rating">
              <Details offer={data} />
              <Price
                data={data}
                is_estimated={this.state.is_price_estimated}
                onClick={this.toggleOfferVariants}
                title={T('show_dates_with_prices')}
              />
              <div className="action">
                <a
                  rel="nofollow"
                  href="javascript:void(0)"
                  title={this.termsLinkTitle(data.subject.name)}
                  className="terms-and-prices"
                  onClick={this.toggleOfferVariants}
                >
                  {this.state.variantsActive
                    ? this.state.variantsActiveText
                    : this.state.variantsInActiveText}
                  <i
                    className={`fa fa-chevron-${
                      this.state.variantsActive ? 'up' : 'down'
                    }`}
                  />
                </a>
                <a
                  rel="nofollow"
                  href={link2ShowHotel(params, data.description_link)}
                  className="choose-offer"
                  title={this.descriptionLinkTitle(data.subject.name)}
                >
                  {T('go_to_description')} <i className="fa fa-chevron-right" />
                </a>
              </div>
            </div>
          </div>
        </div>
        <OfferVariants
          price={data.price_pln}
          offer_type={this.props.offer_type}
          ref="offer_variants"
          active={this.state.variantsActive}
        />
      </article>
    );
  }

  offerVariantsParams() {
    const data = this.props.data;
    return {
      ...this.state.params,
      hotel_id: data.subject.id,
      parser: data.subject.parser,
      operator_code: data.operator.code,
      offer_type: data.offer_type
    };
  }

  offerLinkParams() {
    const data = this.props.data;
    return {
      ...this.state.params,
      id: data.subject.id,
      operator_code: data.operator.code,
      parser: data.subject.parser
    };
  }

  fetchImage = () => {
    const data = this.props.data;
    let params = {
      offer_type: data.offer_type,
      parser: data.subject.parser,
      id: data.subject.id,
      operator_code: data.operator.code
    };
    getHotelDetails(params).then(
      response => {
        if (response.status == 204) {
          this.setState({
            main_image: '/img/placeholder/250x240.png',
            image_loader: false
          });
        } else {
          this.setState({
            main_image: response.data.subject.thumbnail_url,
            image_loader: false
          });
        }
      },
      () => {
        // TODO handle error
        this.setState({
          main_image: '/img/placeholder/250x240.png',
          image_loader: false
        });
      }
    );
  };

  toggleOfferVariants = () => {
    this.setState({ variantsActive: !this.state.variantsActive });
    if (this.state.pristine) {
      this.setState({ pristine: false });
      this.refs['offer_variants'].appendOfferVariants(
        this.offerVariantsParams()
      );
    }
  };

  descriptionLinkTitle(offer_name) {
    return `${T('go_to_description')}: ${offer_name}`;
  }

  termsLinkTitle(offer_name) {
    return `${T('terms_and_prices')}: ${offer_name}`;
  }
}



// WEBPACK FOOTER //
// ./app/javascript/pages/offers/components/offers_list/components/with-hotel/components/list-element.js